import { render } from "./ReportPage.vue?vue&type=template&id=2a256201&scoped=true&ts=true"
import script from "./ReportPage.vue?vue&type=script&lang=ts"
export * from "./ReportPage.vue?vue&type=script&lang=ts"

import "./ReportPage.vue?vue&type=style&index=0&id=2a256201&lang=scss&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a256201"]])

export default __exports__